"use strict";

var React = require('react/addons');
var mixins = require('../mixins');
var _ = require('underscore');
import FieldContainer from 'ofs/react/fields/fieldcontainer';

module.exports = React.createClass({

  bindTo: function(model, key){
    return {
       value: model.get(key),
       requestChange: function(value){
         value = value.replace(/[^0-9\-\+\(\)\s]/,"");
         model.set(key, value);
         var validateFunc = "validate_" + key;
         if (!_.isUndefined(model[validateFunc])) {
           model[validateFunc]();
         }
       }.bind(this)
    };
  },

  render: function() {
    return (
      <FieldContainer label={this.props.label}>
        <input ref="input" type="text" className="ofs-Input" valueLink={this.bindTo(this.props.model, this.props.field)} id={this.props.name} onBlur={this.props.onBlur ? this.props.onBlur : null} />
      </FieldContainer>
    );
  }
});



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/react/fields/phonenumberfield.jsx
 **/